export default __webpack_public_path__ + "static/media/logo.4e8e0a1d.svg";